// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import { connect } from 'react-redux';

import { UserDO, RolePermissionDO } from 'wdna-components';
import { LayoutSkin } from 'wdna-components/lib/layout/types';

import Auth from '../../services/auth/Auth';
import UserMenu from './UserMenu';
import LocationDateIndicator from './LocationDateIndicator';

const defaultLogo: string = 'assets/img/operators/logo.png';

interface Props {
  skinConfig?: LayoutSkin;
}

type State = unknown;

class Header extends React.Component<Props, State> {
  public landing = (): string => {
    const user: UserDO | null = Auth.getUser();
    if (user && user.type === 'cli') {
      const permissions: RolePermissionDO[] = user.role?.role_permissions || [];
      if (permissions) {
        const { permission } = permissions[0].permission || {};
        if (permission === 'dashboard_waste') return '/dashboard/waste';
        if (permission === 'dashboard_gtracking') return '/dashboard/gtracking';
        if (permission === 'dashboard_meteo') return '/dashboard/meteo';
        return '/dashboard/fboard';
      }
    }

    return '/';
  };

  public render(): JSX.Element {
    const { skinConfig } = this.props;

    return (
      <header id="header">
        <div id="logo-group">
          <UserMenu />
        </div>
        <div className="location-date-container">
          <LocationDateIndicator />
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state: any, ownProps: Props): Props => {
  return {
    ...ownProps,
    skinConfig: _.get(state, ['layout', 'skin'], {}),
  };
};

export default connect(mapStateToProps)(Header);
